export const EngineType = [
  { value: "", label: "Select Engine Type" },
  { value: "DetroitDD15", label: "Detroit DD15" },
  { value: "DetroitDD16", label: "Detroit DD16" },
  { value: "DetroitDD17", label: "Detroit DD17" },
  { value: "DetroitDD18", label: "Detroit DD18" },
  { value: "DetroitDD19", label: "Detroit DD19" },
  { value: "DetroitDD20", label: "Detroit DD20" },
  { value: "CumminsX15", label: "Cummins X15" },
  { value: "PaccarMX13", label: "Paccar MX13" },
  { value: "VolvoD13", label: "Volvo D13" },
  { value: "DetroitDieselSeries60", label: "Detroit Diesel Series 60" },
];
